import { Navigate, Route, Routes } from 'react-router-dom';
import AppShell from './components/AppShell';
import ProtectedRoute from './components/ProtectedRoute';
import { useAuth } from './context/AuthContext';
import AccountPage from './routes/AccountPage';
import AlbumEditorPage from './routes/AlbumEditorPage';
import AlbumsPage from './routes/AlbumsPage';
import LibraryPage from './routes/LibraryPage';
import LoginPage from './routes/LoginPage';
import LogoutPage from './routes/LogoutPage';
import NotFoundPage from './routes/NotFoundPage';
import SongEditorPage from './routes/SongEditorPage';
import SongPageViewPage from './routes/SongPageViewPage';
import SongViewPage from './routes/SongViewPage';
import UsersPage from './routes/UsersPage';
import BandsPage from './routes/BandsPage';
import BandPage from './routes/BandPage';
import PreferencesPage from './routes/PreferencesPage';
import { BandRoute, BandManagerRoute } from './context/BandContext';

function App() {
  const { isAuthenticated, isReady } = useAuth();

  return (
    <Routes>
      <Route
        path="/"
        element={
          isReady ? <Navigate to={isAuthenticated ? '/library/songs' : '/login'} replace /> : null
        }
      />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/logout" element={<LogoutPage />} />

      <Route element={<ProtectedRoute />}>
        <Route element={<ProtectedRoute permission="songs:read" />}>
          <Route path="/song/:songId/view" element={<SongPageViewPage />} />
        </Route>

        <Route element={<AppShell />}>
          <Route
            path="/library"
            element={<Navigate to="/library/songs" replace />}
          />
          <Route element={<ProtectedRoute permission="songs:read" />}>
            <Route path="/library/songs" element={<LibraryPage />} />
            <Route path="/song/:songId" element={<SongViewPage />} />
          </Route>
          <Route element={<ProtectedRoute permission="users:songs:read" />}>
            <Route path="/users/:userId/song/:songId" element={<SongViewPage />} />
            <Route path="/users/:userId/song/:songId/view" element={<SongPageViewPage />} />
          </Route>
          <Route element={<ProtectedRoute permission="albums:read" />}>
            <Route path="/library/albums" element={<LibraryPage />} />
            <Route path="/library/albums/:albumId" element={<LibraryPage />} />
            <Route path="/albums" element={<AlbumsPage />} />
          </Route>
          <Route element={<ProtectedRoute permission="songs:write" />}>
            <Route path="/songs/new" element={<SongEditorPage />} />
            <Route path="/songs/:songId/edit" element={<SongEditorPage />} />
          </Route>
          <Route element={<ProtectedRoute permission="albums:write" />}>
            <Route path="/albums/new" element={<AlbumEditorPage />} />
            <Route path="/albums/:albumId/edit" element={<AlbumEditorPage />} />
          </Route>
          <Route path="/preferences" element={<PreferencesPage />}>
            <Route index element={<Navigate to="bands" replace />} />
            <Route element={<ProtectedRoute permission="bands:read" />}>
              <Route path="bands" element={<BandsPage />} />
            </Route>
            <Route element={<ProtectedRoute permission="app:access" />}>
              <Route path="account" element={<AccountPage />} />
            </Route>
            <Route element={<ProtectedRoute permission="users:manage" />}>
              <Route path="users" element={<UsersPage />} />
            </Route>
          </Route>
          <Route path="/account" element={<Navigate to="/preferences/account" replace />} />
          <Route path="/admin/users" element={<Navigate to="/preferences/users" replace />} />
          <Route element={<ProtectedRoute permission="bands:read" />}>
            <Route path="/bands" element={<Navigate to="/preferences/bands" replace />} />
            <Route path="/bands/:bandId" element={<BandRoute />}>
              <Route index element={<BandPage />} />
              <Route path="song/:songId" element={<SongViewPage />} />
              <Route path="song/:songId/view" element={<SongPageViewPage />} />
              <Route element={<BandManagerRoute />}>
                <Route path="songs/new" element={<SongEditorPage />} />
                <Route path="songs/:songId/edit" element={<SongEditorPage />} />
                <Route path="albums/new" element={<AlbumEditorPage />} />
                <Route path="albums/:albumId/edit" element={<AlbumEditorPage />} />
              </Route>
            </Route>
          </Route>
        </Route>
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default App;
